export default "__VITE_ASSET__6a180f7e__"